// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { gaugeSimple16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-gauge-simple': IconGaugeSimple;
    }
}

/**
 * The icon component for the 'gaugeSimple' icon
 */
export class IconGaugeSimple extends IconSvg {
    public constructor() {
        super(gaugeSimple16X16);
    }
}

registerIconSvg('icon-gauge-simple', IconGaugeSimple);
export const iconGaugeSimpleTag = 'nimble-icon-gauge-simple';
